import type { NextPage } from 'next'
import styles from './optionsList.module.scss'
import { GrFormClose } from 'react-icons/gr'

export interface OptionElement {
  label: string
  onClick: () => void
}
interface Props {
  options: OptionElement[]
  visible: boolean
  onOptionClick?: () => void
  onClose: () => void

}
export const OptionsList: NextPage<Props> = ({ options, visible, onClose, onOptionClick }) => {
  return (
    <div className={`${visible ? styles.OptionsList : styles.OptionsList___hide}`}>
      {visible && <>
        <div onClick={onClose} className={styles.OptionsList__close}>
          <GrFormClose />
        </div>
        {
          options.map((option, i) =>
            <div key={i} className={styles.Option} onClick={() => {
              option.onClick()
              if (onOptionClick) {
                onOptionClick()
              }
            }}>
              {option.label}
            </div>
          )
        }
      </>}
    </div>
  )
}
